module.exports = "<div [ngStyle]=\"styleContainer()\" class=\"middleContainer\">\n    <div class=\"innerContainer\">\n        <img src=\"assets/images/par-logo.svg\" alt=\"\">\n        <h1>Sign in to your PAR account</h1>\n        <p>Please sign in with your provided username and password.</p>\n\n        <div class=\"button-wrapper\">\n            <par-button class=\"btn\"buttonText=\"Sign In\" (click)=\"login()\"></par-button>\n        </div>\n    </div> \n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.html
// module id = ./src/app/components/login/login.component.html
// module chunks = main